import { CheckMarkIconStacked, ExclamationMarkIconStacked, InfoMarkIconStacked, WarningIcon } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiAlert = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiAlert: {
      styleOverrides: {
        // the icon will only set the parent container width, i want to set the icon itself which can
        // only be achieved now with classname selector
        root: {
          padding: spacing(1, 2),
          borderRadius: misc.borderRadius(),

          '.MuiAlert-action': {
            padding: spacing(0, 0, 0, 2),

            // close icon
            '& .MuiSvgIcon-root': {
              width: spacing(2.5),
              height: spacing(2.5),
            },
          },

          // severity icon
          '& .MuiAlert-icon': {
            color: 'inherit',

            '& .MuiSvgIcon-root': {
              color: 'inherit',
              width: spacing(3),
              height: spacing(3),
            },
          },

          '& .MuiAlert-message': {
            lineHeight: 1,
          },
        },
        icon: {
          padding: spacing(1, 0),
          marginTop: -1,
          marginRight: spacing(1.75),
          width: spacing(3),
          height: spacing(3),
        },
        message: {
          padding: spacing(1, 0),
          fontSize: spacing(2),
        },
      },
      defaultProps: {
        iconMapping: {
          error: <ExclamationMarkIconStacked fontSize="small" />,
          success: <CheckMarkIconStacked fontSize="small" />,
          warning: <WarningIcon fontSize="small" />,
          info: <InfoMarkIconStacked fontSize="small" />,
        },
      },
      variants: [
        {
          props: { variant: 'standard' },
          style: { border: 0 },
        },
        {
          props: { variant: 'filled' },
          style: { border: 0, color: palette.pure.light },
        },
        {
          props: { variant: 'filled', severity: 'success' },
          style: { backgroundColor: palette.success.dark },
        },
        {
          props: { variant: 'filled', severity: 'warning' },
          style: { backgroundColor: palette.warning.main },
        },
        {
          props: { variant: 'standard', severity: 'error' },
          style: { color: palette.error.dark, backgroundColor: palette.error.light },
        },
        {
          props: { variant: 'standard', severity: 'info' },
          style: { color: palette.info.dark, backgroundColor: palette.info.light },
        },
        {
          props: { variant: 'standard', severity: 'success' },
          style: { color: palette.success.dark, backgroundColor: palette.success.light },
        },
        {
          props: { variant: 'standard', severity: 'warning' },
          style: { backgroundColor: palette.warning.light, color: palette.warning.dark },
        },
        {
          props: { variant: 'outlined', severity: 'error' },
          style: { color: palette.error.dark, borderColor: palette.error.main },
        },
        {
          props: { variant: 'outlined', severity: 'info' },
          style: { color: palette.info.dark, borderColor: palette.info.main },
        },
        {
          props: { variant: 'outlined', severity: 'success' },
          style: { color: palette.success.dark, borderColor: palette.success.main },
        },
        {
          props: { variant: 'outlined', severity: 'warning' },
          style: { borderColor: palette.warning.main, color: palette.warning.dark },
        },
      ],
    },
  }) satisfies ComponentCreation
